import exposedActions, { registerActions } from './actionRegistry';
import exposedServices, { registerServices } from './serviceRegistry';

export const actions = exposedActions;
export const services = exposedServices;

const defaults = {
  registerActions,
  registerServices,
};

export default defaults;
